export default function About(){
    return (
        <>
            <h1>Sobre</h1>
            <p>Louvore está sendo desenvolvido por Eduardo Pinhata.</p>
            <p>Contato: edupinhata@gmail.com</p>
        </>
    );
}